
const hasAccountManagementFF = state => {
  if (!state.userInfo) return false;
  const { feature_flags: featureFlags } = state.userInfo;
  return featureFlags.includes('acct_management');
};

const hasBrokersSalesDemoFF = state => {
  if (!state.userInfo) return false;
  const { feature_flags: featureFlags } = state.userInfo;
  return featureFlags.includes('brokers_sales_demo');
};

const profilePicture = state => {
  const result = {
    profilePictureURL: 0,
    size: 52,
    fontSize: 22,
  }
  if (!state.userInfo) return result;
  const user = state.userInfo;
  result.profilePictureURL = user && user.profile_picture ? user.profile_picture : null;
  return result;
}

const has10DlcCampaignStatusFF = state => {
  if (!state.userInfo) return false;
  const { feature_flags: featureFlags } = state.userInfo;
  return featureFlags.includes('new_10dlc_campaign_status');
};

const hasBetaRelationshipsFF = state => {
  if (!state.userInfo) return false;
  const { feature_flags: featureFlags } = state.userInfo;
  return featureFlags.includes('relationships-beta-tester');
}

const hasRelationshipsReadyTesterFF = state => {
  if (!state.userInfo) return false;
  const { feature_flags: featureFlags } = state.userInfo;
  return featureFlags.includes('relationships-ready-tester');
}

const hasTriedRelationshipsBetaFF = state => {
  if (!state.userInfo) return false;
  const { feature_flags: featureFlags } = state.userInfo;
  return featureFlags.includes('tried-relationships-beta');
}

const hasTestRelationshipsPromptsFF = state => {
  if (!state.userInfo) return false;
  const { feature_flags: featureFlags } = state.userInfo;
  return featureFlags.includes('test-relationships-prompts');
}

const hasSunsetCountdownFF = state => {
  if (!state.userInfo) return false;
  const { feature_flags: featureFlags } = state.userInfo;
  return featureFlags.includes('sunset-countdown');
}

const hasPABSunsetCountdownFF = state => {
  if (!state.userInfo) return false;
  const { feature_flags: featureFlags } = state.userInfo;
  return featureFlags.includes('pab-sunset-countdown');
}

const hasNylasReauthFF = state => {
  if (!state.userInfo) return false;
  const { feature_flags: featureFlags } = state.userInfo;
  return featureFlags.includes('nylas-ms-reauth');
}

export default {
  hasAccountManagementFF,
  profilePicture,
  has10DlcCampaignStatusFF,
  hasBrokersSalesDemoFF,
  hasBetaRelationshipsFF,
  hasRelationshipsReadyTesterFF,
  hasTriedRelationshipsBetaFF,
  hasTestRelationshipsPromptsFF,
  hasSunsetCountdownFF,
  hasPABSunsetCountdownFF,
  hasNylasReauthFF,
};
